(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caroline-imageblock-textbelow"] && !Shopify.designMode) return;
  try {
    
  function triggerSectionFadeIn(container) {
    if (container) {
      container.classList.add('fade-in');
    }
  }

  function initImageBlocksSections(scope = document) {
    const sections = scope.querySelectorAll('.fade-section-container');

    sections.forEach(function(section) {
      triggerSectionFadeIn(section);

      const swiperContainer = section.querySelector('.swiper.image-blocks-wrapper');
      if (!swiperContainer) return;

      const enableSwipeDesktop = swiperContainer.dataset.enableSwipeDesktop === 'true';
      const enableSwipeMobile = swiperContainer.dataset.enableSwipeMobile === 'true';
      const mobileColumns = parseInt(swiperContainer.dataset.mobileColumns) || 1;
      const desktopColumns = parseInt(swiperContainer.dataset.desktopColumns) || 3;

      function shouldEnableSwipe() {
        const isMobile = window.innerWidth <= 760;
        return (isMobile && enableSwipeMobile) || (!isMobile && enableSwipeDesktop);
      }

      let swiperInstance = null;

      function initSwiper() {
        if (swiperInstance) return;

        const isMobile = window.innerWidth <= 760;
        const hideMobilePreviews = swiperContainer.dataset.hideMobilePreviews === 'true';

        const slidesPerViewValue = isMobile
          ? (mobileColumns === 1
              ? (hideMobilePreviews ? 1 : 1.2)
              : 2.2)
          : desktopColumns;

        const spaceBetweenValue = isMobile
          ? (mobileColumns === 1 && hideMobilePreviews ? 0 : 16)
          : 24;

        swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: slidesPerViewValue,
          spaceBetween: spaceBetweenValue,
          pagination: {
            el: section.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: desktopColumns,
              spaceBetween: 24
            }
          },
          on: {
            afterInit: updateNavButtons,
            slideChange: updateNavButtons,
            reachBeginning: updateNavButtons,
            reachEnd: updateNavButtons,
            fromEdge: updateNavButtons
          }
        });

        swiperContainer.classList.add('swiper-active');
      }

      function updateNavButtons(swiper) {
        const prevButton = swiper.el.querySelector('.swiper-button-prev');
        const nextButton = swiper.el.querySelector('.swiper-button-next');

        if (swiper.isBeginning) {
          prevButton.style.display = 'none';
        } else {
          prevButton.style.display = 'flex';
        }

        if (swiper.isEnd) {
          nextButton.style.display = 'none';
        } else {
          nextButton.style.display = 'flex';
        }
      }

      function destroySwiper() {
        if (swiperInstance) {
          swiperInstance.destroy();
          swiperInstance = null;
          swiperContainer.classList.remove('swiper-active');
        }
      }

      function handleResize() {
        if (shouldEnableSwipe()) {
          initSwiper();
        } else {
          destroySwiper();
        }
      }

      handleResize();
      window.addEventListener('resize', handleResize);
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initImageBlocksSections();
  });

  document.addEventListener('shopify:section:load', function(event) {
    initImageBlocksSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvet-multiple-image-blocks"] && !Shopify.designMode) return;
  try {
    
  function triggerSectionFadeIn(container) {
    if (container) {
      container.classList.add('fade-in');
    }
  }

  function initImageBlocksSections(scope = document) {
    const sections = scope.querySelectorAll('.fade-section-container');

    sections.forEach(function(section) {
      triggerSectionFadeIn(section);

      const swiperContainer = section.querySelector('.swiper.image-blocks-wrapper');
      if (!swiperContainer) return;

      const enableSwipeDesktop = swiperContainer.dataset.enableSwipeDesktop === 'true';
      const enableSwipeMobile = swiperContainer.dataset.enableSwipeMobile === 'true';
      const mobileColumns = parseInt(swiperContainer.dataset.mobileColumns) || 1;
      const desktopColumns = parseInt(swiperContainer.dataset.desktopColumns) || 3;

      function shouldEnableSwipe() {
        const isMobile = window.innerWidth <= 760;
        return (isMobile && enableSwipeMobile) || (!isMobile && enableSwipeDesktop);
      }

      let swiperInstance = null;

      function initSwiper() {
        if (swiperInstance) return;

        const isMobile = window.innerWidth <= 760;
        const hideMobilePreviews = swiperContainer.dataset.hideMobilePreviews === 'true';

        const slidesPerViewValue = isMobile
          ? (mobileColumns === 1
              ? (hideMobilePreviews ? 1 : 1.2)
              : 2.2)
          : desktopColumns;

        const spaceBetweenValue = isMobile
          ? (mobileColumns === 1 && hideMobilePreviews ? 0 : 16)
          : 24;

        swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: slidesPerViewValue,
          spaceBetween: spaceBetweenValue,
          pagination: {
            el: section.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: desktopColumns,
              spaceBetween: 24
            }
          },
          on: {
            afterInit: updateNavButtons,
            slideChange: updateNavButtons,
            reachBeginning: updateNavButtons,
            reachEnd: updateNavButtons,
            fromEdge: updateNavButtons
          }
        });

        swiperContainer.classList.add('swiper-active');
      }


      function updateNavButtons(swiper) {
        const prevButton = swiper.el.querySelector('.swiper-button-prev');
        const nextButton = swiper.el.querySelector('.swiper-button-next');

        if (swiper.isBeginning) {
          prevButton.style.display = 'none';
        } else {
          prevButton.style.display = 'flex';
        }

        if (swiper.isEnd) {
          nextButton.style.display = 'none';
        } else {
          nextButton.style.display = 'flex';
        }
      }

      function destroySwiper() {
        if (swiperInstance) {
          swiperInstance.destroy();
          swiperInstance = null;
          swiperContainer.classList.remove('swiper-active');
        }
      }

      function handleResize() {
        if (shouldEnableSwipe()) {
          initSwiper();
        } else {
          destroySwiper();
        }
      }

      handleResize();
      window.addEventListener('resize', handleResize);
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initImageBlocksSections();
  });

  document.addEventListener('shopify:section:load', function(event) {
    initImageBlocksSections(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
